import { combineReducers } from 'redux';
import activityReducer from './reducers/activityReducer';
import sessionReducer from './reducers/sessionReducer';
import roundReducer from './reducers/roundReducer';
import alexReducer from './reducers/alexReducer';
import dragAndDropReducer from './reducers/dragAndDropReducer';
import practiceReducer from './reducers/practiceReducer';
import onboardingReducer from './reducers/onboardingReducer';
import uxReducer from './reducers/uxReducer';

export default combineReducers({
  activityReducer,
  sessionReducer,
  roundReducer,
  alexReducer,
  dragAndDropReducer,
  practiceReducer,
  onboardingReducer,
  uxReducer,
});
